/*LIBRARY*/
import { useCallback } from "react";
import { connect } from "react-redux";

/*COMPONENT*/
import SPINNER from "../common_spinner/SPINNER";

/*REDUX*/
import {
  set_value_sini_data,
  convert_text_to_number,
} from "../../App/actions/sini_data_actions";
import { push_layer_id_ai } from "../../App/actions/ai_preset_actions";
import { getDetailLayerById } from "../../App/actions/get_features_action";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

// Robust string to number conversion function (snake_case variables)
function robust_string_to_number(value) {
  if (value === null || value === undefined) return 0;

  if (typeof value !== "string") {
    const num = Number(value);
    return isNaN(num) ? 0 : num;
  }

  let str = value.trim();

  if (
    str === "" ||
    str.toLowerCase() === "nan" ||
    str.toLowerCase() === "undefined"
  ) {
    return 0;
  }

  const last_comma = str.lastIndexOf(",");
  const last_dot = str.lastIndexOf(".");

  let decimal_separator = null;

  if (last_comma > last_dot) decimal_separator = ",";
  else if (last_dot > last_comma) decimal_separator = ".";

  if (decimal_separator === ",") {
    str = str.replace(/\./g, "");
    str = str.replace(/,/g, ".");
  } else if (decimal_separator === ".") {
    str = str.replace(/,/g, "");
  } else {
    str = str.replace(/[.,]/g, "");
  }

  const num = parseFloat(str);
  return isNaN(num) ? 0 : num;
}

const S_D_CONVERT = ({
  // Props destructuring
  auth,
  layer,
  project,
  loading_reducer,
  sini_data_reducer,
  toggle_convert,
  // Action props
  convert_text_to_number: convertTextToNumber,
  getDetailLayerById: getDetailLayer,
  properties,
  mode_edit,
}) => {
  const on_convert = useCallback(() => {
    const { current_chat } = sini_data_reducer;
    const { layer_id } = layer;
    let field_key = "";
    if (mode_edit === "sini_ai") {
      field_key =
        current_chat?.result_list?.[0]?.result_object?.gen_color?.field_key;
    } else {
      const { style_parameter } = properties;
      field_key = style_parameter.field_key;
    }
    const body = {
      geo_layer_id: layer_id,
      properties_key: field_key,
    };
    convertTextToNumber(body);
  }, [sini_data_reducer, layer, convertTextToNumber, mode_edit, properties]);

  const on_refresh_layer = useCallback(() => {
    toggle_convert();

    const { layer_id } = layer;
    const { geo_project } = project;
    const body = {
      geo_layer_id: layer_id,
      geo_project_id: geo_project._id,
    };
    getDetailLayer(body);
  }, [toggle_convert, layer, project, getDetailLayer]);

  //local storage
  const language = localStorage?.language || auth.language;

  //local state

  //global props
  const { convert_progress, current_chat } = sini_data_reducer;
  const { loading_item_array } = loading_reducer;
  const { layer_id, geo_layer_list } = layer;
  const { style_parameter } = properties;

  //content
  const features =
    geo_layer_list?.find((item) => item?.geo_layer?._id === layer_id)?.geo_layer
      ?.geojson?.features || [];
  const features_sample = features.slice(0, 10);

  let { name, field_key } = style_parameter;

  if (mode_edit === "sini_ai") {
    name = current_chat?.result_list?.[0]?.result_object?.gen_color?.name;
    field_key =
      current_chat?.result_list?.[0]?.result_object?.gen_color?.field_key;
  }

  return (
    <main>
      <h1 className="margin_bottom">
        {dict?.["Convert text column to numbers"]?.[language]}
      </h1>
      <div className="two_container_equal">
        <section className="container background_white outline_shadow_soft margin_bottom">
          <p className="text_medium sub_color">
            {dict?.["Columns to be processed:"]?.[language]}
          </p>
          <p className="text_big margin_bottom_extra">{name}</p>

          <p className="text_medium sub_color">
            {dict?.["Notes"]?.[language]}:
          </p>
          <p className="text_big container red_container margin_bottom_extra">
            {
              dict?.[
                "This process will OVERWRITE and cannot be undone. Please ensure you have checked carefully."
              ]?.[language]
            }
            :
            <br />
            <br />
            {
              dict?.[
                "All text in the column will be overwritten into numbers using the conversion process approach."
              ]?.[language]
            }
            :
          </p>

          <p className="text_medium sub_color margin_bottom">
            {dict?.["Repair sample"]?.[language]}:
          </p>
          <table className="table full_width">
            <tbody>
              <tr>
                <td>No</td>
                <td>{dict?.["Value Before"]?.[language]}</td>
                <td>{dict?.["Value After"]?.[language]}</td>
              </tr>
            </tbody>
            <tbody>
              {features_sample.map((feature, idx) => {
                return (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>"{feature?.properties?.[field_key]}"</td>
                    <td>
                      {robust_string_to_number(
                        feature?.properties?.[field_key]
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <br />
          {loading_item_array.includes("convert_text_to_number") ? (
            <button className="button_big background_black margin_bottom_extra">
              {dict?.["Processing"]?.[language]}{" "}
              <SPINNER
                unik="ai_spinner"
                width={10}
                border={0.25}
                color1="white"
                color2="#28a3f5"
              />
            </button>
          ) : (
            <button
              className="button_big background_black margin_bottom_extra"
              onClick={on_convert}
            >
              {dict?.["The process of converting to numbers"]?.[language]}
            </button>
          )}

          {convert_progress === "success" ? (
            <div className="margin_bottom_extra">
              <p className="text_medium sub_color margin_bottom">
                {dict?.["Conversion process successful"]?.[language]}
              </p>
              <button
                className="button_big background_black"
                onClick={on_refresh_layer}
              >
                {dict?.["Refresh layer contents"]?.[language]}
              </button>
            </div>
          ) : convert_progress === "failed" ? (
            <div className="margin_bottom_extra">
              <p className="text_medium sub_color">
                {dict?.["Conversion process failed"]?.[language]}
              </p>
            </div>
          ) : (
            <></>
          )}
        </section>

        <section className="container background_white outline_shadow_soft margin_bottom">
          <p className="text_medium sub_color margin_bottom">
            {dict?.["Example of improvement"]?.[language]}:
          </p>
          <table className="table">
            <thead>
              <tr>
                <th>{dict?.["Example before"]?.[language]}</th>
                <th>{dict?.["Example output"]?.[language]}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>"123abc"</td>
                <td>123</td>
              </tr>
              <tr>
                <td>"7,3"</td>
                <td>7.3</td>
              </tr>
              <tr>
                <td>"1.234,56"</td>
                <td>1234.56</td>
              </tr>
              <tr>
                <td>"abc123"</td>
                <td>0</td>
              </tr>
              <tr>
                <td>"12.34xyz"</td>
                <td>12.34</td>
              </tr>
              <tr>
                <td>"7..3"</td>
                <td>0</td>
              </tr>
              <tr>
                <td>"1,234.56"</td>
                <td>1234.56</td>
              </tr>
              <tr>
                <td>"NaN"</td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
  properties: state.properties,
});

export default connect(mapStateToProps, {
  set_value_sini_data,
  convert_text_to_number,
  getDetailLayerById,
  push_layer_id_ai,
})(S_D_CONVERT);
